import { useEffect, useRef } from 'react';
import { useProductionPlanQueryParams } from '../hooks';
import { useProductionPlanSearchStore } from '../store';
import { closeProductionPlanSearchDrawer } from './ProductionPlanSearchDrawer';

export const useCloseSearchOnViewChange = () => {
  const {
    queryParams: { view },
  } = useProductionPlanQueryParams();
  const resetSearch = useProductionPlanSearchStore((state) => state.reset);
  const previousView = useRef(view);

  useEffect(() => {
    if (previousView.current === view) {
      return;
    }

    previousView.current = view;
    closeProductionPlanSearchDrawer();
    resetSearch();
  }, [view, resetSearch]);
};
